import React from "react";
import { Helmet } from "react-helmet-async";

// Full-site maintenance screen. Rendered in place of the router when
// REACT_APP_MAINTENANCE is "true" at build time — see App.js.
const MaintenanceMode = () => (
  <>
    <Helmet>
      <title>Under Maintenance | Salary Uncle</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>

    <div style={styles.page}>
      <main style={styles.card}>
        <div style={styles.mark} aria-hidden="true">
          &#128736;
        </div>
        <h1 style={styles.heading}>We&rsquo;ll be back shortly</h1>
        <p style={styles.text}>
          Salary Uncle is temporarily unavailable while we carry out scheduled
          maintenance.
        </p>
        <p style={styles.text}>
          Please check back in a little while. Thank you for your patience.
        </p>
        <p style={styles.brand}>Salary Uncle</p>
      </main>
    </div>
  </>
);

// Inline styles so the screen renders even if the app's CSS fails to load.
const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
    background: "#f6f7f9",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
  card: {
    maxWidth: 520,
    width: "100%",
    background: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: 14,
    padding: "40px 32px",
    textAlign: "center",
    boxShadow: "0 1px 3px rgba(0,0,0,.06)",
  },
  mark: {
    width: 56,
    height: 56,
    margin: "0 auto 20px",
    borderRadius: "50%",
    background: "#eef2ff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 26,
  },
  heading: { margin: "0 0 12px", fontSize: 22, lineHeight: 1.3, color: "#1a1a1a" },
  text: { margin: "0 0 10px", fontSize: 15, lineHeight: 1.6, color: "#4b5563" },
  brand: { marginTop: 28, fontSize: 13, color: "#9ca3af" },
};

export default MaintenanceMode;
